export default __webpack_public_path__ + "static/media/ArrowRight.5214579a.svg";